<div class="container-fluid">
  @if (processes) {
    <rbb-table [responsiveBreakpoint]="'lg'" [columns]="columns" [values]="processes"
               [pageSizes]="[0, 20, 50, 100]" [selectedPageSize]="20" [hideColumns]="true"
               [search]="true" searchType="SEPARATE" [resultNumbers]="true" [additionalNavigationAtTop]="true"
               [tableData]="tableData" [sort]="true" (trClick)="routeToProcess($event)" (trAuxClick)="routeToProcess($event, '_blank')"/>
    <ng-template let-column="column" let-value="value" #tableData>
      <td>
        @switch (column.field) {
          @case ('name') {
            <span class="fw-bold">{{value[column.field]}}</span>
          }
          @case ('previewData') {
            @for (s of value[column.field]; track s) {
              <div>
                <span class="badge bg-secondary text-start mb-1">
                  @let parts = s.split(': ');
                  <span class="fw-normal d-block">{{utilService.removeStyleMarkup(parts[0])}}:</span>
                  @for (p of parts.slice(1).join(': ').split(', '); track p) {
                    <span class="d-block text-wrap mt-1">{{p}}</span>
                  }
                </span>
              </div>
            }
          }
          @case ('timestamp') {
            {{value[column.field] | date:'dd.MM.yyyy HH:mm'}}
          }
          @case ('resubmitted') {
            {{value[column.field] | date:'dd.MM.yyyy'}}
          }
          @case ('status') {
            @switch (value[column.field]) {
              @case (ProcessStatus.DRAFT) {
                <span class="text-secondary"><i class="fas fa-pen" aria-hidden="true"></i>&ensp;Entwurf @if (value.changedByOther){von {{value.changedByOther}}}</span>
              }
              @case (ProcessStatus.SENT) {
                <span class="text-secondary"><i class="fas fa-hourglass-half" aria-hidden="true"></i>&ensp;Warte auf Genehmigung</span>
              }
              @case (ProcessStatus.IN_PROGRESS) {
                <span class="text-secondary"><i class="fas fa-hourglass-half" aria-hidden="true"></i>&ensp;Wird bearbeitet</span>
              }
              @case (ProcessStatus.FINISHED) {
                <span class="text-success"><i class="fas fa-check" aria-hidden="true"></i>&ensp;Abgeschlossen</span>
              }
              @case (ProcessStatus.REJECTED) {
                <span class="text-danger"><i class="fas fa-times" aria-hidden="true"></i>&ensp;Bearbeitung zurückgewiesen</span>
              }
              @case (ProcessStatus.APPROVED) {
                <span class="text-secondary"><i class="fas fa-hourglass-half" aria-hidden="true"></i>&ensp;Warte auf Bearbeitung</span>
              }
              @case (ProcessStatus.TRANSMITTED) {
                <span class="text-success"><i class="fas fa-check" aria-hidden="true"></i>&ensp;Übermittelt</span>
              }
              @case (ProcessStatus.TRANSMISSION_FAILED) {
                <span class="text-danger"><i class="fas fa-times" aria-hidden="true"></i>&ensp;Übermittlung fehlgeschlagen</span>
              }
              @case (ProcessStatus.OLD) {
                <span class="text-danger"><i class="fas fa-times" aria-hidden="true"></i>&ensp;Veraltet</span>
              }
              @case (ProcessStatus.DECLINED) {
                <span class="text-danger"><i class="fas fa-times" aria-hidden="true"></i>&ensp;Abgelehnt</span>
              }
              @case (ProcessStatus.CANCELED) {
                <span class="text-danger"><i class="fas fa-times" aria-hidden="true"></i>&ensp;Storniert</span>
              }
              @case (ProcessStatus.CANCELED_AFTER_APPROVED) {
                <span class="text-danger"><i class="fas fa-times" aria-hidden="true"></i>&ensp;Storniert nach Genehmigung</span>
              }
              @case (ProcessStatus.UNKNOWN) {
                <span class="text-secondary"><i class="fas fa-check" aria-hidden="true"></i>&ensp;Bearbeitungsstatus unbekannt</span>
              }
            }
          }
          @case ('open') {
            <a routerLink="/processes/{{value.id}}" (auxclick)="$event.stopPropagation()">
              <i class="fa-solid fa-arrow-right d-inline-block pointer" data-bs-toggle="tooltip" data-bs-placement="top" title="Antrag öffnen"></i>
            </a>
          }
          @default {
            {{ value[column.field] }}
          }
        }
      </td>
    </ng-template>
  }
</div>
